import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "@env/environment";
import { Observable } from "rxjs/Observable";
import { BaseResponse } from "@app/data/shared/models/base-response";

@Injectable()
export class UserService {
  private baseUrl() {
    return (
      (localStorage.getItem("apiUrl")
        ? localStorage.getItem("apiUrl")
        : environment.apiUrl) + "/"
    );
  }

  constructor(private http: HttpClient) {}

  my(token?: string): Observable<BaseResponse<any>> {
    return token
      ? this.http.get<BaseResponse<any>>(this.baseUrl() + "/user/my", {
          headers: new HttpHeaders().set("Authorization", "Bearer " + token),
        })
      : this.http.get<BaseResponse<any>>(this.baseUrl() + "/user/my");
  }
}
